import React from "react";
import { useGetInsurancesQuery } from "../../redux/service/demographic_services";
import { AppListing } from "../../components/appListing";
import moment from "moment";

function Insurance({ crossHandler }) {
  const { data: insurancesData, isLoading } = useGetInsurancesQuery();
  const cols = [
    { title: "Type", key: "type_ordinal" },
    { title: "Plan Name", key: "plan_name" },
    { title: "Relationship", key: "subscriber_relationship_title" },
    { title: "Policy Number", key: "policy_number" },
    {
      title: "Date",
      getData: (data) => {
        const originalDate = moment(data?.date).format("l");
        return originalDate;
      },
    },
    {
      title: "Status",
      getData: (data) => {
        return data?.active ? "Active" : "";
      },
    },
  ];
  return (
    <div>
      <div className="flex justify-between items-center bg-gray-100 px-1 py-1.5 pb-3 rounded-t-[10px]">
        <h3 className="text-3xl font-medium tracking-wide">Insurances</h3>
        <div onClick={crossHandler}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2.5}
            stroke="currentColor"
            className="w-6 h-6 mr-2 text-blue-600 hover:text-gray-600 cursor-pointer"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </div>
      </div>
      <div className="mt-3">
        <AppListing
          loading={isLoading}
          listData={insurancesData?.data || []}
          cols={cols}
        />
      </div>
    </div>
  );
}

export default Insurance;
